define('components/factory/Factory', [
    'components/factory/enum/EnumViewType',
    'components/factory/models/MultiItemsModel',
    'components/factory/models/MultiMediasModel',
    'components/factory/models/ProductModel',
    'components/factory/models/MultiProductsModel',
    'components/factory/models/VideoModel',
    'components/factory/models/VideoProductModel',
    'components/factory/models/ShareModel',
    'components/factory/models/ViewerModel',
    'components/factory/views/MultiItemsView',
    'components/factory/views/MultiMediasView',
    'components/factory/views/ProductView',
    'components/factory/views/MultiProductsView',
    'components/factory/views/VideoView',
    'components/factory/views/VideoProductView',
    'components/factory/views/ShareView',
    'components/factory/views/ViewerView'
], function( EnumViewType, MultiItemsModel, MultiMediasModel, ProductModel, MultiProductsModel, VideoModel, VideoProductModel, ShareModel, ViewerModel,
        MultiItemsView, MultiMediasView, ProductView, MultiProductsView, VideoView, VideoProductView, ShareView, ViewerView ){

    var delegate = null;

    var initialize = function( options ){
        delegate = options.delegate;
    };

    var createModelFromData = function( data ){
        if( !_.isString( data.type ) || !_.isString( data.viewId ) ){
            return 0;
        }

        var _model = null;

        if( delegate ){
            _model = delegate.createModelFromData( data );
        }

        if( _.isNull( _model ) ){
            var modelDatas = $.extend(true, {}, data);

            switch( data.type ){
                case EnumViewType.PRODUCT_VIEW:
                    _model = new ProductModel( modelDatas );
                    break;

                case EnumViewType.MULTIPRODUCTS_VIEW:
                    if (modelDatas.suffixClass === "grid") {
                        if (modelDatas.products.length > 6) {
                            modelDatas.showMoreBtn = true;
                        }

                        _.each(modelDatas.products, function(element, index, list) {
                            if (index >= 6) {
                                element.isHidden = true;
                            }
                        });
                    }
                    _model = new MultiProductsModel( modelDatas );
                    break;

                case EnumViewType.MULTIITEMS_VIEW:
                    var globalCounter = 0;

                    _.each( modelDatas.items, function( item, index ) {
                        if( !modelDatas.isMobile ){
                            var itemWeight = parseInt( item.weight, 10 );

                            if( (globalCounter % modelDatas.lineWeight) + itemWeight > modelDatas.lineWeight ) {
                                item.weight = modelDatas.lineWeight - (globalCounter % modelDatas.lineWeight);
                            }

                            globalCounter += item.weight;
                        }
                    });

                    var tmpWeight = 0;
                    var spliceIndex = 0;

                    if( modelDatas.isMobile ){
                        spliceIndex = modelDatas.lineWeight * modelDatas.maxLinesToShow;
                    } else {
                        _.each( modelDatas.items, function( item, index ) {
                            tmpWeight += parseInt( item.weight, 10 );

                            if( tmpWeight <= (modelDatas.lineWeight * modelDatas.maxLinesToShow) ){
                                spliceIndex = index + 1;
                            }
                        });
                    }

                    modelDatas.pendingItems = modelDatas.items.splice(spliceIndex, modelDatas.items.length);
                    modelDatas.moreItemToLoad = modelDatas.pendingItems.length !== 0;

                    _model = new MultiItemsModel( modelDatas );
                    break;

                case EnumViewType.MULTIMEDIAS_VIEW:
                    _model = new MultiMediasModel( modelDatas );
                    break;

                case EnumViewType.VIDEO_VIEW:
                    _model = new VideoModel( modelDatas );
                    break;

                case EnumViewType.VIDEOPRODUCT_VIEW:
                    _model = new VideoProductModel( modelDatas );
                    break;

                case EnumViewType.SHARE_VIEW:
                    _model = new ShareModel( modelDatas );
                    break;

                case EnumViewType.VIEWER_VIEW:
                    _model = new ViewerModel( modelDatas );
                    break;

                default:
                    break;
            }
        }

        if( _.isNull( _model ) ){
            console.warn("[Factory] Can't create model of this type : " + data.type);
        }

        return _model;

    };

    var createViewFromModel = function( _model ){
        if( _.isNull( _model ) || !_.isString( _model.get('type') ) || !_.isString( _model.get('viewId') ) ){
            return 0;
        }

        var _view = null;

        if( delegate ){
            _view = delegate.createViewFromModel( _model );
        }

        if( _.isNull( _view ) ){

            switch( _model.get('type') ){
                case EnumViewType.PRODUCT_VIEW:
                    _view = new ProductView( { model : _model, factory: subFactory } );
                    break;

                case EnumViewType.MULTIPRODUCTS_VIEW:
                    _view = new MultiProductsView( { model : _model, factory: subFactory } );
                    break;

                case EnumViewType.MULTIITEMS_VIEW:
                    _view = new MultiItemsView( { model : _model, factory: subFactory } );
                    break;

                case EnumViewType.MULTIMEDIAS_VIEW:
                    _view = new MultiMediasView( { model : _model, factory: subFactory } );
                    break;

                case EnumViewType.VIDEO_VIEW:
                    _view = new VideoView( { model : _model, factory: subFactory } );
                    break;

                case EnumViewType.VIDEOPRODUCT_VIEW:
                    _view = new VideoProductView( { model : _model, factory: subFactory } );
                    break;

                case EnumViewType.SHARE_VIEW:
                    _view = new ShareView( { model : _model, factory: subFactory } );
                    break;

                case EnumViewType.VIEWER_VIEW:
                    _view = new ViewerView( { model : _model, factory: subFactory } );
                    break;

                default:
                    break;
            }
        }

        if( _.isNull( _view ) ){
            console.warn("[Factory] Can't create view of this type : " + _model.get('type') );
        }

        return _view;
    };

    var subFactory = {
        createModelFromData: createModelFromData,
        createViewFromModel: createViewFromModel
    };

    return {
        initialize: initialize,
        createModelFromData: createModelFromData,
        createViewFromModel: createViewFromModel
    };

});

